import { composeFavoriteLineup, composePersonalLineup, ChannelsPersonalization } from './personalization';
import { composeOperatorsLineup } from './personalization/composeOperatorsLineup';
import { ChannelsSettings } from './settings/getChannelsSettings';
import { ChannelAsset } from './types';

type ComposeChannelsArgs = {
  channelAssetsMap: Map<number, ChannelAsset>;
  channelCollection: Array<number>;
  entitledChannels: Set<number>;
  personalization: ChannelsPersonalization;
  settings: ChannelsSettings;
};

/**
 * @see https://kaltura.atlassian.net/wiki/spaces/KUXINT/pages/4201775593/Personalized+Channel+List+Allow+viewer+to+create+a+personal+list+using+drag+and+drop
 */
export function composeChannels({
  channelAssetsMap,
  channelCollection,
  entitledChannels,
  personalization,
  settings,
}: ComposeChannelsArgs) {
  if ('favoriteChannels' in personalization) {
    return composeFavoriteLineup({
      channelAssetsMap,
      channelCollection,
      entitledChannels,
      favoriteChannels: personalization.favoriteChannels,
      lastWatched: personalization.lastWatched,
      mostWatched: personalization.mostWatched,
      orderBatches: settings.orderBatches,
    });
  }

  if ('personalLineup' in personalization && personalization.personalLineup) {
    return composePersonalLineup({
      channelAssetsMap,
      channelCollection,
      entitledChannels,
      lastWatched: personalization.lastWatched,
      personalLineup: personalization.personalLineup,
    });
  }

  return composeOperatorsLineup({
    channelAssetsMap,
    channelCollection,
    entitledChannels,
    lastWatched: personalization.lastWatched,
  });
}
